export const DividerDT = {
	divider: {
		css: ({ dt }) => `
          .p-divider-horizontal-no-margin.p-divider-horizontal {
              margin: 0 !important;
          }
        `,
	},
};
